import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const DocumentationService = {
    getDocumentationById: (id) => {
        return http.get(`${baseUrl}/cliami/documentations/${id}`);
    },

    getDocumentations: () => {
        return http.get(`${baseUrl}/cliami/documentations`);
    },

    getDocumentationsByAppId: (appId) => {
        return http.get(`${baseUrl}/cliami/documentations/appId/${appId}`);
    },

    saveDocumentation: (documentation, documentationId) => {
        const formData = new FormData();
        formData.append('AppId', documentation.appId || '');
        formData.append('Name', documentation.name || '');
        formData.append('Content', documentation.content || '');
        if (documentation.file) {
            formData.append('file', documentation.file);
        }
        if (!documentationId) {
            return http.post(`${baseUrl}/cliami/documentations/create`, formData);
        } else {
            return http.put(`${baseUrl}/cliami/documentations/update/${documentationId}`, formData);
        }
    },

    deleteDocumentation: (documentationId) => {
        return http.delete(`${baseUrl}/cliami/documentations/${documentationId}`);
    },
};

export default DocumentationService;
